import { render, staticRenderFns } from "./SecaoVazia.vue?vue&type=template&id=757996c6"
import script from "./SecaoVazia.vue?vue&type=script&lang=ts"
export * from "./SecaoVazia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports